import { Radio as MUIRadio, RadioProps } from '@mui/material';

export { type RadioProps } from '@mui/material';

export function Radio(props: RadioProps) {
  return <MUIRadio {...props} />;
}
